import NumberFormat, { InputAttributes, NumberFormatProps } from 'react-number-format';

type FormattedNumberProps<T = InputAttributes> = Readonly<NumberFormatProps<T>>;
export function FormattedNumber<T>(props: FormattedNumberProps<T>) {
  if (props.displayType === 'input') {
    return <NumberFormat<T> thousandSeparator={true} decimalScale={2} displayType='input' {...props} />;
  }

  return <NumberFormat<T> thousandSeparator={true} decimalScale={2} displayType='text' {...props} />;
}
